module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-6.df0e8e2d.jpg";